import React from "react";
import { CircularProgress } from "@material-ui/core";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Centered = styled.div`
  margin: auto;
  text-align: center;
`;

export interface ILoginStatusProps {
  message: string;
}

export default (props: ILoginStatusProps) => (
  <Container>
    <Centered>
      <CircularProgress />
      <h1>{props.message}</h1>
    </Centered>
  </Container>
);
